import { useCallback } from 'react';

/**
 * Custom hook for parsing and converting filter values between JSON and comma-separated formats
 */
export const useFilterParser = () => {
  // Parse filter string (JSON or comma-separated) to array
  const parseFilterString = useCallback((str: string): string[] => {
    if (!str) return [];
    try {
      const parsed = JSON.parse(str);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return str.split(",").filter(Boolean);
    }
  }, []);

  // Convert array to comma-separated string for API
  const toCommaSeparated = useCallback((str: string): string => {
    if (!str) return "";
    try {
      const parsed = JSON.parse(str);
      return Array.isArray(parsed) ? parsed.join(",") : str;
    } catch {
      return str;
    }
  }, []);

  // Convert array to JSON string
  const toJsonString = useCallback((arr: string[]): string => {
    return arr.length > 0 ? JSON.stringify(arr) : "";
  }, []);

  return {
    parseFilterString,
    toCommaSeparated,
    toJsonString,
  };
};
